<div [ngClass]="{'loader-hidden': !show}">
  <div class="loader-overlay">
    <div>
      <img class="loader" src="/assets/images/ajax-reload.gif" />
    </div>
  </div>
</div>
<div [ngClass]="{'in': show, 'modal-backdrop': show, 'fade':show}"></div>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/loader/loader.component.html